import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { header3 } from 'styles/texts'
import { searchFocus } from 'actions'
import { savedConsultantIdsSelector } from 'selectors'
import ConsultantList from 'components/ConsultantList'
import Button from 'components/Button'

const Empty = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Text = styled.div`
  ${header3};
  margin-bottom: 28px;
`

const Saved = ({ consultantIds, searchFocus }) =>
  consultantIds.length > 0 ? (
    <ConsultantList
      consultantIds={consultantIds}
      title={count =>
        count === 1 ? 'lagret konsulent' : 'lagrede konsulenter'}
    />
  ) : (
    <Empty>
      <Text>
        Ingen lagrede ungdom{' '}
        <span role="img" aria-label="sad">
          😞
        </span>
      </Text>
      <Button onClick={searchFocus}>Søk etter ungdom</Button>
    </Empty>
  )

const mapStateToProps = state => ({
  consultantIds: savedConsultantIdsSelector(state) || [],
})

const mapDispatchToProps = { searchFocus }

export default connect(mapStateToProps, mapDispatchToProps)(Saved)



// WEBPACK FOOTER //
// ./src/pages/Saved.js